export function createReportRepository(config) {
    const { repository, client } = config;
    function toReport(data) {
        return {
            id: data.id,
            title: data.title ?? 'Untitled',
            description: data.description,
            status: data.status,
            stack: data.stack,
            lastEditedBy: data.last_edited_by,
            lastEditedAt: data.last_edited_at,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
        };
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'find', props],
                async queryFn() {
                    const response = await client.user.content.list({
                        limit: 25,
                        type: 'report',
                    });
                    return response.data.map(toReport);
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'lookup', props],
                async queryFn() {
                    const response = await client.user.content.retrieve(props.id);
                    return toReport(response);
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportRepository.js.map